import { render, staticRenderFns } from "./UserAccount.vue?vue&type=template&id=23209b9c&scoped=true"
import script from "./UserAccount.vue?vue&type=script&lang=js"
export * from "./UserAccount.vue?vue&type=script&lang=js"
import style0 from "./UserAccount.vue?vue&type=style&index=0&id=23209b9c&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23209b9c",
  null
  
)

export default component.exports